import {
  getPets,
  deletePet as deletePetEndpoint,
  putPet,
} from '@front/common/endpoints'
import { Pet } from '@front/common/types'
import { Ref } from '@vue/composition-api'
import { useStore, useVuex } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'

import useCustomer from '../Customer/Customer.hook'

import { INSERT_PETS, DELETE_PET, UPDATE_PET } from './constants'

const usePet = (id = 0) => {
  const store = useStore()
  const { useGetters } = useVuex()
  const { fetchCustomer } = useCustomer()

  const [_onFetchPetsSuccess, fetchPetsState, fetchPetsAction]: any[] =
    useApiState(getPets)
  const [onDeletePetSuccess, deletedPetState, deletePet]: any[] =
    useApiState(deletePetEndpoint)
  const [onUpdatePetSuccess, updatePetState, updatePet]: any[] =
    useApiState(putPet)

  async function fetchPets() {
    const data = await fetchPetsAction()

    store.commit(INSERT_PETS, data)
  }

  onDeletePetSuccess(async () => {
    store.commit(DELETE_PET, id)

    fetchPets()
    fetchCustomer()
  })

  onUpdatePetSuccess((data) => {
    store.commit(UPDATE_PET, data)
  })

  return {
    ...(useGetters({
      pets: 'pet/get',
    }) as { pets: Ref<Pet[]> }),
    fetchPetsState,
    deletedPetState,
    fetchPets,
    deletePet,
    updatePet,
    updatePetState,
  }
}

export default usePet
